<SidebarShell
  :logo="short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="select_menu_item(default_menu_item)"
>
  <!-- HEADER ACTIONS -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions" />
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      main_label="Mining"
      sub_label="Mine Operations"
      icon="bi bi-minecart-loaded"
      :sectors="sectors"
      active_sector="mining"
      :items="[]"
      :open="dropdownOpen"
      :top_label="can_view_portfolio ? entity_name : ''"
      :top_subtitle="entity_subtitle"
      @toggle="toggleDropdown"
      @select-sector="select_sector"
      @select-top="go_to_overview"
    />
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu px-3 mt-3 w-100">
      <div
        v-for="item in menu_items"
        :key="item.key"
        role="button"
        tabindex="0"
        class="sidebar-menu-item d-flex align-items-center position-relative py-2 px-2 mb-1 rounded-3 w-100 cursor-pointer"
        :class="[
          active_menu_item === item.key
            ? 'bg-danger-subtle text-danger border-start border-3 border-danger'
            : 'text-muted'
        ]"
        :aria-label="item.badge ? `${item.label} (${item.badge})` : item.label"
        :aria-current="active_menu_item === item.key ? 'page' : null"
        @click="select_menu_item(item.key)"
        @keydown.enter.prevent="select_menu_item(item.key)"
        @keydown.space.prevent="select_menu_item(item.key)"
      >
        <i
          :class="[
            item.icon,
            'sidebar-menu-icon',
            'me-2',
            active_menu_item === item.key ? 'text-danger' : 'text-muted'
          ]"
        ></i>

        <p class="sidebar-menu-label sidebar-menu-text fw-semibold text-xs mb-0 flex-grow-1 text-truncate">
          {{ item.label }}
        </p>

        <span
          v-if="item.badge"
          class="sidebar-menu-text badge rounded-pill border text-xxs flex-shrink-0"
          :class="badge_class(item)"
        >
          {{ item.badge }}
        </span>
      </div>
    </div>
  </template>
</SidebarShell>
